/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
    'use strict';
    /*globals Tc*/

    /**
     * Edition Navigation
     *
     * @author Zeljko Curcic
     * @namespace Tc.Module
     * @class Editionnavigation
     * @extends Tc.Module
     */
    Tc.Module.Editionnavigation = Tc.Module.extend({

        on: function (callback) {
            var mod = this;

            mod.$ctx.attr('id','EditionNav' + mod.id);
            mod.listItems = mod.$ctx.find('.carousel-list > li');
            mod.prevButtonSelector = '#' + mod.$ctx.attr('id') + ' .carousel-prev';
            mod.nextButtonSelector = '#' + mod.$ctx.attr('id') + ' .carousel-next';
            mod.carouselHeight = 0;
            mod.currentIndex = (mod.$ctx.data('current-index') > -1) ? mod.$ctx.data('current-index') : mod.listItems.length-1;
            mod.initiallyHidden = mod.$ctx.hasClass('hide');

            mod.initCarousel();

            mod.$ctx.on('click', '.close-button', function(e){
                e.preventDefault();
                mod.$ctx.addClass('hide');
                $('.link-editionnav').removeClass('active');
                $('.mod-content, .mod-article').removeClass('hide');
                mod.fire('editionChange', {'edition' : $('.header-edition-title').data('edition'), 'year' : $('.header-edition-title').data('year')}, ['editionnav']);
            });

            callback();
        },

        initCarousel: function(){
            var mod = this;

            if (mod.initiallyHidden) mod.$ctx.removeClass('hide');

            mod.$ctx.find('.carousel-clip').jCarouselLite({
                btnNext: mod.nextButtonSelector,
                btnPrev: mod.prevButtonSelector,
                visible: 1,
                circular: false,
                start: mod.currentIndex,
                afterEnd: function($current) {
                    mod.fire('editionChange', {'edition' : $current.data('issue'), 'year' : $current.data('year')}, ['editionnav']);
                }
            });

            if (mod.initiallyHidden) mod.$ctx.addClass('hide');
            if(mod.currentIndex >= mod.listItems.length -1 ) {
                $(mod.nextButtonSelector).addClass('disabled');
            }
        }
    });
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/dialogue/js/modules/Tc.Module.Editionnavigation.js
// module id = 105
// module chunks = 0